import { ThemeKey } from "@smartsheet/design-tokens";
import React, { forwardRef } from "react";
import { ReactNode } from "react";
import { useTheme } from "../../../theme/utils/useTheme";
import { TypeRampV2Props } from "../../typography";
import { ursaTypeRampDefinitions } from "../../typography/constants/ursaConstants";
import { ChipLabelStyled } from "../styled/ChipLabelStyled";
import { SharedChipProps } from "../types";

const chipLabelTypeRampTheme = {
    medium: "Inter--12px--600w",
    small: "Inter--12px--600w",
    xsmall: "Inter--12px--600w",
} as const;

export interface ChipLabelProps extends Pick<TypeRampV2Props, "omitTooltip"> {
    children: ReactNode;
    size: Exclude<SharedChipProps["size"], undefined>;
}

export const ChipLabel = forwardRef<HTMLSpanElement, ChipLabelProps>(({ children, omitTooltip, size }, ref) => {
    const ursaVariant = ursaTypeRampDefinitions[chipLabelTypeRampTheme[size]];
    const { key } = useTheme();
    const themeMode = key as ThemeKey;

    return (
        <ChipLabelStyled
            // Lodestar and Ursa Chips both use the same font styles.
            system="ursa"
            variant={chipLabelTypeRampTheme[size]}
            omitTooltip={omitTooltip}
            lineClamp={1}
            ref={ref}
            themeMode={themeMode}
            chipSize={size}
            {...ursaVariant}
        >
            {children}
        </ChipLabelStyled>
    );
});

ChipLabel.displayName = "ChipLabel";
